import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { EmployeeModel } from '../models';

export function useGetAllEmployeeWithObj() {
  const initial: { employeesWithObj: Record<string, EmployeeModel> } = {
    employeesWithObj: {}
  };
  const permissions = useAppSelector(state => state?.userReducer?.user?.role?.permissions);
  const isActivityLogs = permissions?.includes(Permissions.PERMISSION_ACTIVITY_LOGS);

  const { data = initial, ...arg } = useQuery<{ employeesWithObj: Record<string, EmployeeModel> }>(
    ['EMPLOYEES_WITH_OBJ'],
    async () => {
      const { data } = await $api.get('/v1/activity-logs/employee');
      const result: Record<string, EmployeeModel> = {};

      (data?.data as EmployeeModel[])?.forEach(({ id, ...other }) => {
        result[id] = { id, ...other };
      });

      return { employeesWithObj: result };
    },
    {
      enabled: isActivityLogs
    }
  );

  return { ...data, ...arg };
}
